// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: relative_date.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AggregationType, aggregationTypeFromJSON, aggregationTypeToJSON } from "./enums";

export const protobufPackage = "com.meritic.newton";

/** Type of date period. */
export enum DatePeriodEnum {
  DAY = 0,
  WEEK = 1,
  MONTH = 2,
  QUARTER = 3,
  YEAR = 4,
  UNRECOGNIZED = -1,
}

export function datePeriodEnumFromJSON(object: any): DatePeriodEnum {
  switch (object) {
    case 0:
    case "DAY":
      return DatePeriodEnum.DAY;
    case 1:
    case "WEEK":
      return DatePeriodEnum.WEEK;
    case 2:
    case "MONTH":
      return DatePeriodEnum.MONTH;
    case 3:
    case "QUARTER":
      return DatePeriodEnum.QUARTER;
    case 4:
    case "YEAR":
      return DatePeriodEnum.YEAR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DatePeriodEnum.UNRECOGNIZED;
  }
}

export function datePeriodEnumToJSON(object: DatePeriodEnum): string {
  switch (object) {
    case DatePeriodEnum.DAY:
      return "DAY";
    case DatePeriodEnum.WEEK:
      return "WEEK";
    case DatePeriodEnum.MONTH:
      return "MONTH";
    case DatePeriodEnum.QUARTER:
      return "QUARTER";
    case DatePeriodEnum.YEAR:
      return "YEAR";
    case DatePeriodEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Type of quarters of a year. */
export enum QuarterEnum {
  Q1 = 0,
  Q2 = 1,
  Q3 = 2,
  Q4 = 3,
  UNRECOGNIZED = -1,
}

export function quarterEnumFromJSON(object: any): QuarterEnum {
  switch (object) {
    case 0:
    case "Q1":
      return QuarterEnum.Q1;
    case 1:
    case "Q2":
      return QuarterEnum.Q2;
    case 2:
    case "Q3":
      return QuarterEnum.Q3;
    case 3:
    case "Q4":
      return QuarterEnum.Q4;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QuarterEnum.UNRECOGNIZED;
  }
}

export function quarterEnumToJSON(object: QuarterEnum): string {
  switch (object) {
    case QuarterEnum.Q1:
      return "Q1";
    case QuarterEnum.Q2:
      return "Q2";
    case QuarterEnum.Q3:
      return "Q3";
    case QuarterEnum.Q4:
      return "Q4";
    case QuarterEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Months of a year. */
export enum MonthEnum {
  JANUARY = 0,
  FEBRUARY = 1,
  MARCH = 2,
  APRIL = 3,
  MAY = 4,
  JUNE = 5,
  JULY = 6,
  AUGUST = 7,
  SEPTEMBER = 8,
  OCTOBER = 9,
  NOVEMBER = 10,
  DECEMBER = 11,
  UNRECOGNIZED = -1,
}

export function monthEnumFromJSON(object: any): MonthEnum {
  switch (object) {
    case 0:
    case "JANUARY":
      return MonthEnum.JANUARY;
    case 1:
    case "FEBRUARY":
      return MonthEnum.FEBRUARY;
    case 2:
    case "MARCH":
      return MonthEnum.MARCH;
    case 3:
    case "APRIL":
      return MonthEnum.APRIL;
    case 4:
    case "MAY":
      return MonthEnum.MAY;
    case 5:
    case "JUNE":
      return MonthEnum.JUNE;
    case 6:
    case "JULY":
      return MonthEnum.JULY;
    case 7:
    case "AUGUST":
      return MonthEnum.AUGUST;
    case 8:
    case "SEPTEMBER":
      return MonthEnum.SEPTEMBER;
    case 9:
    case "OCTOBER":
      return MonthEnum.OCTOBER;
    case 10:
    case "NOVEMBER":
      return MonthEnum.NOVEMBER;
    case 11:
    case "DECEMBER":
      return MonthEnum.DECEMBER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MonthEnum.UNRECOGNIZED;
  }
}

export function monthEnumToJSON(object: MonthEnum): string {
  switch (object) {
    case MonthEnum.JANUARY:
      return "JANUARY";
    case MonthEnum.FEBRUARY:
      return "FEBRUARY";
    case MonthEnum.MARCH:
      return "MARCH";
    case MonthEnum.APRIL:
      return "APRIL";
    case MonthEnum.MAY:
      return "MAY";
    case MonthEnum.JUNE:
      return "JUNE";
    case MonthEnum.JULY:
      return "JULY";
    case MonthEnum.AUGUST:
      return "AUGUST";
    case MonthEnum.SEPTEMBER:
      return "SEPTEMBER";
    case MonthEnum.OCTOBER:
      return "OCTOBER";
    case MonthEnum.NOVEMBER:
      return "NOVEMBER";
    case MonthEnum.DECEMBER:
      return "DECEMBER";
    case MonthEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Types of date filters. */
export enum DateFilterType {
  LAST_N_PERIOD = 0,
  THIS_PERIOD = 1,
  NEXT_N_PERIOD = 2,
  PERIOD_TO_DATE = 3,
  YEAR_ONLY = 4,
  QUARTER_YEAR = 5,
  MONTH_YEAR = 6,
  EXACT_DATE_RANGE = 7,
  EXACT_DATE = 8,
  UNRECOGNIZED = -1,
}

export function dateFilterTypeFromJSON(object: any): DateFilterType {
  switch (object) {
    case 0:
    case "LAST_N_PERIOD":
      return DateFilterType.LAST_N_PERIOD;
    case 1:
    case "THIS_PERIOD":
      return DateFilterType.THIS_PERIOD;
    case 2:
    case "NEXT_N_PERIOD":
      return DateFilterType.NEXT_N_PERIOD;
    case 3:
    case "PERIOD_TO_DATE":
      return DateFilterType.PERIOD_TO_DATE;
    case 4:
    case "YEAR_ONLY":
      return DateFilterType.YEAR_ONLY;
    case 5:
    case "QUARTER_YEAR":
      return DateFilterType.QUARTER_YEAR;
    case 6:
    case "MONTH_YEAR":
      return DateFilterType.MONTH_YEAR;
    case 7:
    case "EXACT_DATE_RANGE":
      return DateFilterType.EXACT_DATE_RANGE;
    case 8:
    case "EXACT_DATE":
      return DateFilterType.EXACT_DATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DateFilterType.UNRECOGNIZED;
  }
}

export function dateFilterTypeToJSON(object: DateFilterType): string {
  switch (object) {
    case DateFilterType.LAST_N_PERIOD:
      return "LAST_N_PERIOD";
    case DateFilterType.THIS_PERIOD:
      return "THIS_PERIOD";
    case DateFilterType.NEXT_N_PERIOD:
      return "NEXT_N_PERIOD";
    case DateFilterType.PERIOD_TO_DATE:
      return "PERIOD_TO_DATE";
    case DateFilterType.YEAR_ONLY:
      return "YEAR_ONLY";
    case DateFilterType.QUARTER_YEAR:
      return "QUARTER_YEAR";
    case DateFilterType.MONTH_YEAR:
      return "MONTH_YEAR";
    case DateFilterType.EXACT_DATE_RANGE:
      return "EXACT_DATE_RANGE";
    case DateFilterType.EXACT_DATE:
      return "EXACT_DATE";
    case DateFilterType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Types of Growth Benchmark. */
export enum GrowthBenchmarkType {
  GENERALIZED_GROWTH_BENCHMARK = 0,
  PRIOR_PERIOD = 1,
  PRIOR_YEAR = 2,
  LAST_N_PERIOD_AGGREGATION = 3,
  UNRECOGNIZED = -1,
}

export function growthBenchmarkTypeFromJSON(object: any): GrowthBenchmarkType {
  switch (object) {
    case 0:
    case "GENERALIZED_GROWTH_BENCHMARK":
      return GrowthBenchmarkType.GENERALIZED_GROWTH_BENCHMARK;
    case 1:
    case "PRIOR_PERIOD":
      return GrowthBenchmarkType.PRIOR_PERIOD;
    case 2:
    case "PRIOR_YEAR":
      return GrowthBenchmarkType.PRIOR_YEAR;
    case 3:
    case "LAST_N_PERIOD_AGGREGATION":
      return GrowthBenchmarkType.LAST_N_PERIOD_AGGREGATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GrowthBenchmarkType.UNRECOGNIZED;
  }
}

export function growthBenchmarkTypeToJSON(object: GrowthBenchmarkType): string {
  switch (object) {
    case GrowthBenchmarkType.GENERALIZED_GROWTH_BENCHMARK:
      return "GENERALIZED_GROWTH_BENCHMARK";
    case GrowthBenchmarkType.PRIOR_PERIOD:
      return "PRIOR_PERIOD";
    case GrowthBenchmarkType.PRIOR_YEAR:
      return "PRIOR_YEAR";
    case GrowthBenchmarkType.LAST_N_PERIOD_AGGREGATION:
      return "LAST_N_PERIOD_AGGREGATION";
    case GrowthBenchmarkType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** DateRange represents the dates between the given range. */
export interface DateRange {
  /** Epoch in seconds for the lower bound of the date range (inclusive) */
  low_epoch_sec?:
    | number
    | undefined;
  /** Epoch in seconds for the upper bound of the date range (inclusive) */
  high_epoch_sec?: number | undefined;
}

/** Representation of date filter. */
export interface DateFilter {
  /** Type of date filter. */
  type?:
    | DateFilterType
    | undefined;
  /** Date period (e.g., DAY, WEEK). */
  date_period?:
    | DatePeriodEnum
    | undefined;
  /** Number of periods (e.g., last 7 days). */
  number?:
    | number
    | undefined;
  /** Exact date range. */
  date_range?:
    | DateRange
    | undefined;
  /** Specific year. */
  year?:
    | number
    | undefined;
  /** Specific quarter. */
  quarter?:
    | QuarterEnum
    | undefined;
  /** Specific month. */
  month?:
    | MonthEnum
    | undefined;
  /**
   * Reference date epoc used to calculate the start or end dates for various relative date filters.
   * These filters include:
   * - LAST_N_PERIOD: Calculates dates for the last N periods relative to the reference date.
   * - NEXT_N_PERIOD: Calculates dates for the next N periods relative to the reference date.
   * - THIS_PERIOD: Determines the current period based on the reference date.
   * - PERIOD_TO_DATE: Calculates the range from the start of the period to the reference date.
   * If a reference date is provided, it will be used; otherwise, today's date is taken by default.
   * For EXACT_DATE, this epoch is used as the date to filter on (default today).
   */
  reference_date_epoc_sec?:
    | number
    | undefined;
  /**
   * Absolute date filter corresponding to the relative date filter represented by this proto.
   * This is used by clients to display the absolute date filter, so that client does not have to calculate the absolute date range.
   * For example, THIS_MONTH with reference date 2nd Dec 2024 will have absolute date filter for MONTH_YEAR DEC 2024.
   */
  absolute_date_filter?: DateFilter | undefined;
}

/** Representation of Growth benchmark. */
export interface GrowthBenchmarkProto {
  /** Type of growth benchmark. */
  growth_type?:
    | GrowthBenchmarkType
    | undefined;
  /** Number of periods (e.g., last 7 days). */
  number?:
    | number
    | undefined;
  /** Aggregation type. */
  aggregation_type?: AggregationType | undefined;
  growth_period?:
    | DatePeriodEnum
    | undefined;
  /**
   * Absolute date filter corresponding to this growth benchmark.
   * This is used by clients to display the date filter corresponding to this growth benchmark.
   * For example, PRIOR_PERIOD for July 2024 will have absolute date filter for MONTH_YEAR JUNE 2024.
   * For example, PRIOR_YEAR for July 2024 will have absolute date filter for MONTH_YEAR JULY 2023.
   * For example, LAST_4_WEEK_AVG for LAST_WEEK will have date filter with the correct absolute date range and period=WEEK.
   * @Deprecated: Corresponding absolute date filter is present in versus benchmark itself.
   */
  absolute_date_filter?: DateFilter | undefined;
}

function createBaseDateRange(): DateRange {
  return { low_epoch_sec: undefined, high_epoch_sec: undefined };
}

export const DateRange: MessageFns<DateRange> = {
  encode(message: DateRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.low_epoch_sec !== undefined) {
      writer.uint32(8).int64(message.low_epoch_sec);
    }
    if (message.high_epoch_sec !== undefined) {
      writer.uint32(16).int64(message.high_epoch_sec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDateRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.low_epoch_sec = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.high_epoch_sec = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DateRange {
    return {
      low_epoch_sec: isSet(object.low_epoch_sec) ? globalThis.Number(object.low_epoch_sec) : undefined,
      high_epoch_sec: isSet(object.high_epoch_sec) ? globalThis.Number(object.high_epoch_sec) : undefined,
    };
  },

  toJSON(message: DateRange): unknown {
    const obj: any = {};
    if (message.low_epoch_sec !== undefined) {
      obj.low_epoch_sec = Math.round(message.low_epoch_sec);
    }
    if (message.high_epoch_sec !== undefined) {
      obj.high_epoch_sec = Math.round(message.high_epoch_sec);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateRange>, I>>(base?: I): DateRange {
    return DateRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateRange>, I>>(object: I): DateRange {
    const message = createBaseDateRange();
    message.low_epoch_sec = object.low_epoch_sec ?? undefined;
    message.high_epoch_sec = object.high_epoch_sec ?? undefined;
    return message;
  },
};

function createBaseDateFilter(): DateFilter {
  return {
    type: undefined,
    date_period: undefined,
    number: undefined,
    date_range: undefined,
    year: undefined,
    quarter: undefined,
    month: undefined,
    reference_date_epoc_sec: undefined,
    absolute_date_filter: undefined,
  };
}

export const DateFilter: MessageFns<DateFilter> = {
  encode(message: DateFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.date_period !== undefined) {
      writer.uint32(16).int32(message.date_period);
    }
    if (message.number !== undefined) {
      writer.uint32(24).int32(message.number);
    }
    if (message.date_range !== undefined) {
      DateRange.encode(message.date_range, writer.uint32(34).fork()).join();
    }
    if (message.year !== undefined) {
      writer.uint32(40).int32(message.year);
    }
    if (message.quarter !== undefined) {
      writer.uint32(48).int32(message.quarter);
    }
    if (message.month !== undefined) {
      writer.uint32(56).int32(message.month);
    }
    if (message.reference_date_epoc_sec !== undefined) {
      writer.uint32(64).int64(message.reference_date_epoc_sec);
    }
    if (message.absolute_date_filter !== undefined) {
      DateFilter.encode(message.absolute_date_filter, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDateFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.date_period = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.number = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.date_range = DateRange.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.year = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.quarter = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.month = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.reference_date_epoc_sec = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.absolute_date_filter = DateFilter.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DateFilter {
    return {
      type: isSet(object.type) ? dateFilterTypeFromJSON(object.type) : undefined,
      date_period: isSet(object.date_period) ? datePeriodEnumFromJSON(object.date_period) : undefined,
      number: isSet(object.number) ? globalThis.Number(object.number) : undefined,
      date_range: isSet(object.date_range) ? DateRange.fromJSON(object.date_range) : undefined,
      year: isSet(object.year) ? globalThis.Number(object.year) : undefined,
      quarter: isSet(object.quarter) ? quarterEnumFromJSON(object.quarter) : undefined,
      month: isSet(object.month) ? monthEnumFromJSON(object.month) : undefined,
      reference_date_epoc_sec: isSet(object.reference_date_epoc_sec)
        ? globalThis.Number(object.reference_date_epoc_sec)
        : undefined,
      absolute_date_filter: isSet(object.absolute_date_filter)
        ? DateFilter.fromJSON(object.absolute_date_filter)
        : undefined,
    };
  },

  toJSON(message: DateFilter): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = dateFilterTypeToJSON(message.type);
    }
    if (message.date_period !== undefined) {
      obj.date_period = datePeriodEnumToJSON(message.date_period);
    }
    if (message.number !== undefined) {
      obj.number = Math.round(message.number);
    }
    if (message.date_range !== undefined) {
      obj.date_range = DateRange.toJSON(message.date_range);
    }
    if (message.year !== undefined) {
      obj.year = Math.round(message.year);
    }
    if (message.quarter !== undefined) {
      obj.quarter = quarterEnumToJSON(message.quarter);
    }
    if (message.month !== undefined) {
      obj.month = monthEnumToJSON(message.month);
    }
    if (message.reference_date_epoc_sec !== undefined) {
      obj.reference_date_epoc_sec = Math.round(message.reference_date_epoc_sec);
    }
    if (message.absolute_date_filter !== undefined) {
      obj.absolute_date_filter = DateFilter.toJSON(message.absolute_date_filter);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateFilter>, I>>(base?: I): DateFilter {
    return DateFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateFilter>, I>>(object: I): DateFilter {
    const message = createBaseDateFilter();
    message.type = object.type ?? undefined;
    message.date_period = object.date_period ?? undefined;
    message.number = object.number ?? undefined;
    message.date_range = (object.date_range !== undefined && object.date_range !== null)
      ? DateRange.fromPartial(object.date_range)
      : undefined;
    message.year = object.year ?? undefined;
    message.quarter = object.quarter ?? undefined;
    message.month = object.month ?? undefined;
    message.reference_date_epoc_sec = object.reference_date_epoc_sec ?? undefined;
    message.absolute_date_filter = (object.absolute_date_filter !== undefined && object.absolute_date_filter !== null)
      ? DateFilter.fromPartial(object.absolute_date_filter)
      : undefined;
    return message;
  },
};

function createBaseGrowthBenchmarkProto(): GrowthBenchmarkProto {
  return {
    growth_type: undefined,
    number: undefined,
    aggregation_type: undefined,
    growth_period: undefined,
    absolute_date_filter: undefined,
  };
}

export const GrowthBenchmarkProto: MessageFns<GrowthBenchmarkProto> = {
  encode(message: GrowthBenchmarkProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.growth_type !== undefined) {
      writer.uint32(8).int32(message.growth_type);
    }
    if (message.number !== undefined) {
      writer.uint32(16).int32(message.number);
    }
    if (message.aggregation_type !== undefined) {
      writer.uint32(24).int32(message.aggregation_type);
    }
    if (message.growth_period !== undefined) {
      writer.uint32(32).int32(message.growth_period);
    }
    if (message.absolute_date_filter !== undefined) {
      DateFilter.encode(message.absolute_date_filter, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GrowthBenchmarkProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGrowthBenchmarkProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.growth_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.number = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.aggregation_type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.growth_period = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.absolute_date_filter = DateFilter.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GrowthBenchmarkProto {
    return {
      growth_type: isSet(object.growth_type) ? growthBenchmarkTypeFromJSON(object.growth_type) : undefined,
      number: isSet(object.number) ? globalThis.Number(object.number) : undefined,
      aggregation_type: isSet(object.aggregation_type) ? aggregationTypeFromJSON(object.aggregation_type) : undefined,
      growth_period: isSet(object.growth_period) ? datePeriodEnumFromJSON(object.growth_period) : undefined,
      absolute_date_filter: isSet(object.absolute_date_filter)
        ? DateFilter.fromJSON(object.absolute_date_filter)
        : undefined,
    };
  },

  toJSON(message: GrowthBenchmarkProto): unknown {
    const obj: any = {};
    if (message.growth_type !== undefined) {
      obj.growth_type = growthBenchmarkTypeToJSON(message.growth_type);
    }
    if (message.number !== undefined) {
      obj.number = Math.round(message.number);
    }
    if (message.aggregation_type !== undefined) {
      obj.aggregation_type = aggregationTypeToJSON(message.aggregation_type);
    }
    if (message.growth_period !== undefined) {
      obj.growth_period = datePeriodEnumToJSON(message.growth_period);
    }
    if (message.absolute_date_filter !== undefined) {
      obj.absolute_date_filter = DateFilter.toJSON(message.absolute_date_filter);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GrowthBenchmarkProto>, I>>(base?: I): GrowthBenchmarkProto {
    return GrowthBenchmarkProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GrowthBenchmarkProto>, I>>(object: I): GrowthBenchmarkProto {
    const message = createBaseGrowthBenchmarkProto();
    message.growth_type = object.growth_type ?? undefined;
    message.number = object.number ?? undefined;
    message.aggregation_type = object.aggregation_type ?? undefined;
    message.growth_period = object.growth_period ?? undefined;
    message.absolute_date_filter = (object.absolute_date_filter !== undefined && object.absolute_date_filter !== null)
      ? DateFilter.fromPartial(object.absolute_date_filter)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
